const DiscountCouponOfferSvg = ({
  width = 18,
  height = 14,
  viewBox = '0 0 18 14',
  className = '',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
  className?: string;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" className={className}>
      <path
        d="M5.66857 10.1429L12.0971 3.71429M0.5 12.0714C0.499999 12.412 0.635105 12.7386 0.875667 12.9797C1.11623 13.2207 1.4426 13.3565 1.78314 13.3571H15.9311C16.2717 13.3565 16.5981 13.2207 16.8386 12.9797C17.0792 12.7386 17.2143 12.412 17.2143 12.0714V9.45629C16.6591 9.30575 16.169 8.97665 15.8195 8.5198C15.4701 8.06295 15.2807 7.50376 15.2807 6.92857C15.2807 6.35339 15.4701 5.7942 15.8195 5.33734C16.169 4.88049 16.6591 4.55139 17.2143 4.40086V1.78571C17.2143 1.44517 17.0792 1.11853 16.8386 0.877485C16.5981 0.63644 16.2717 0.500681 15.9311 0.5H1.78314C1.4426 0.500681 1.11623 0.63644 0.875667 0.877485C0.635105 1.11853 0.499999 1.44517 0.5 1.78571V4.39571C1.05957 4.54289 1.55465 4.87122 1.90793 5.32944C2.26122 5.78766 2.45282 6.34997 2.45282 6.92857C2.45282 7.50717 2.26122 8.06948 1.90793 8.5277C1.55465 8.98592 1.05957 9.31425 0.5 9.46143V12.0714Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.766 4.81178C6.64545 4.93234 6.48193 5.00007 6.31144 5.00007C6.14094 5.00007 5.97743 4.93234 5.85687 4.81178C5.73631 4.69122 5.66858 4.52771 5.66858 4.35721C5.66858 4.18672 5.73631 4.0232 5.85687 3.90264C5.97743 3.78208 6.14094 3.71436 6.31144 3.71436C6.48193 3.71436 6.64545 3.78208 6.766 3.90264C6.88656 4.0232 6.95429 4.18672 6.95429 4.35721C6.95429 4.52771 6.88656 4.69122 6.766 4.81178Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9089 9.95464C11.7883 10.0752 11.6248 10.1429 11.4543 10.1429C11.2838 10.1429 11.1203 10.0752 10.9997 9.95464C10.8792 9.83408 10.8114 9.67057 10.8114 9.50007C10.8114 9.32957 10.8792 9.16606 10.9997 9.0455C11.1203 8.92494 11.2838 8.85721 11.4543 8.85721C11.6248 8.85721 11.7883 8.92494 11.9089 9.0455C12.0294 9.16606 12.0972 9.32957 12.0972 9.50007C12.0972 9.67057 12.0294 9.83408 11.9089 9.95464Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DiscountCouponOfferSvg;
